import React from 'react';
import ArangoDownloadPage from './components/ArangoDownloadPage';
import './styles/tailwind.css';
import './styles/main.css';

function App() {
  return (
    <div className="App">
      <ArangoDownloadPage />
    </div>
  );
}

export default App;
